<template>
  <div :class="classes">
    <div v-if="showImg" :class="prefixCls + '__img'">
      <img :src="imgUrl" alt="">
    </div>
    <p :class="prefixCls + '__desc'">{{ desc }}</p>
    <slot></slot>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '@/utils/constants'
const EMPTY_PREFIX_CLASS = `${PREFIX_CLASS}empty`
export default {
  name: 'TEmpty',
  props: {
    imgUrl: {
      type: String,
      default: require('../../assets/images/empty-img.png')
    },
    desc: {
      type: String,
      default: '暂无数据'
    },
    showImg: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      validator(value) {
        /* istanbul ignore next */
        return ['sm', 'lg', ''].includes(value)
      },
      default: ''
    }
  },
  data() {
    return {
      prefixCls: EMPTY_PREFIX_CLASS
    }
  },
  computed: {
    classes() {
      return [
        `${EMPTY_PREFIX_CLASS}`,
        {
          [`${EMPTY_PREFIX_CLASS}--sm`]: this.size === 'sm',
          [`${EMPTY_PREFIX_CLASS}--lg`]: this.size === 'lg',
          [`${EMPTY_PREFIX_CLASS}--no-img`]: !this.showImg
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/module/empty/empty.vue